"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Root = exports.Html = exports.HeaderText = exports.HeaderContainer = void 0;
var _mui = require("@ori-ui/mui");
var _presentationComponents = require("@ori/presentation-components");
const Root = exports.Root = (0, _mui.styled)('div')(({
  theme
}) => ({
  display: 'flex',
  width: '100%',
  flexDirection: 'column',
  alignItems: 'center',
  gap: theme.spacing(3),
  padding: theme.spacing(0, 3),
  [theme.breakpoints.up('md')]: {
    gap: theme.spacing(6),
    [`.${_presentationComponents.tableClasses.root}`]: {
      margin: '0 auto'
    }
  }
}));
const HeaderText = exports.HeaderText = (0, _mui.styled)(_mui.Typography)({
  display: '-webkit-box',
  overflow: 'hidden',
  WebkitLineClamp: 2,
  WebkitBoxOrient: 'vertical',
  textOverflow: 'ellipsis'
});
const HeaderContainer = exports.HeaderContainer = (0, _mui.styled)('div')(({
  theme
}) => ({
  display: 'flex',
  flexDirection: 'column',
  width: '100%',
  gap: theme.spacing(4),
  '&:empty': {
    display: 'none'
  }
}));
const Html = exports.Html = (0, _mui.styled)(_presentationComponents.TextWithHtml)(({
  theme
}) => ({
  [`.${_presentationComponents.textWithHtmlClasses.text}`]: {
    fontSize: theme.typography.body1.fontSize
  }
}));
